import { render } from "./DisClosedDialog.vue?vue&type=template&id=98759be8"
import script from "./DisClosedDialog.vue?vue&type=script&lang=js"
export * from "./DisClosedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__